import { h } from 'preact';
import { useContext, useMemo } from 'preact/hooks';
import { ItemsContext } from './ItemsProvider';

const BundleItem = ({ item }) => {
  const { dispatch, state } = useContext(ItemsContext);

  const itemState = useMemo(() => {
    return {
      id: item.variant.id,
      quantity: item.quantity,
      maxQuantity: item.maxQuantity,
      available: item.variant.available,
    };
  }, [item.quantity]);

  const changeQuantity = (newQuantity) => {
    const quantityInt = parseInt(newQuantity);
    const minQ = 0;
    const maxQ = itemState.maxQuantity;
    dispatch({
      type: 'CHANGE_QUANTITY',
      payload: {
        id: itemState.id,
        quantity: quantityInt >= minQ && quantityInt <= maxQ ? quantityInt : 0,
      },
    });
  };

  return (
    <li className="bundle-item">
      <span>
        {item.product.title}
        {/* <br />
        <span style="color: #8e8e8e;">
          $
          {itemState.quantity > 0
            ? ((item.variant.price * item.quantity) / 100).toFixed(2)
            : (item.variant.price / 100).toFixed(2)}
        </span> */}
      </span>

      {itemState.available ? (
        <div className="btn-group">
          <button
            class="quantity-control-btn"
            onClick={() => {
              changeQuantity(itemState.quantity - 1);
            }}
            aria-label={`Decrease quantity of ${item.product.title} by 1`}
            disabled={itemState.quantity <= 0}
          >
            -
          </button>
          <input
            type="number"
            max="9"
            class="quantity"
            onChange={(e) => {
              changeQuantity(e.currentTarget.value);
            }}
            value={itemState.quantity}
          />
          <button
            class="quantity-control-btn"
            onClick={() => {
              changeQuantity(itemState.quantity + 1);
            }}
            aria-label={`Increase quantity of ${item.product.title} by 1`}
            disabled={itemState.quantity >= itemState.maxQuantity}
          >
            +
          </button>
        </div>
      ) : (
        <span>item sold out</span>
      )}
    </li>
  );
};

export default BundleItem;
